import Endpoint from './endpoint'

const authUrl = process.env.VUE_APP_AUTHENTICATOR_API_URL

export default class Auth extends Endpoint {
  async login(email, password) {
    let url = new URL('/login', authUrl)

    let [jwt, res] = await this.request(url, {
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify({ email, password })
    })

    if (!res.status.toString().startsWith('2')) {
      throw new Error('Not authorized')
    }
    return [jwt, res]
  }
}
